export function formatCurrency(value: number | string) {
  return new Intl.NumberFormat('ru-ru', { style: 'currency', currency: 'RUB' }).format(
    Number(value)
  );
}
